export default "__VITE_ASSET__B8gDRC1w__"